import React, { useState } from 'react';
import moment from 'moment';
import InputCellRender from 'components/reactStrapTable/components/tableCellRender/InputCellRender';
import CheckBoxCellRender from 'components/reactStrapTable/components/tableCellRender/CheckBoxCellRender';
import CommnetsCellRender from 'components/reactStrapTable/components/tableCellRender/CommnetsCellRender';
import StatusCellRender from 'components/reactStrapTable/components/tableCellRender/StatusCellRender';
import InputDateCellRender from 'components/reactStrapTable/components/tableCellRender/InputDateCellRender';
import InputNumberCellRender from 'components/reactStrapTable/components/tableCellRender/inputNumberCellRender';
import DrugStatusCellRender from '../tableCellRender/DrugStatusCellRender';
import InputNumericNumberCellRender from '../tableCellRender/InputNumericNumberCellRender';

const CellEditRender = (props) => {
  
  const {
    row,
    col,
    alwaysEditableCheckbox,
    formatterType,
    onChange,
    hasTouched = false,
    disabled = false,
    requiredFields = [],
    editPhoneNumber,
    listArray,
    err1,
    crosswalktab,
    errstatus,
    errAccountNum,
    reasonErr,
    redflag,
    wacErr,wacErrZero,endDateFormatter,
    terminationDateProp,
    showWarning,
    effectiveTempDate,
    setEffectiveTempDate,
    validationError
  } = props;
  
  const { edit, dataField: columnName } = col;
   

  const handleStatusChange = (claimStatusID,columnName) => {
    onChange(claimStatusID, columnName);
  };

  if (row?.isEdit && edit) {
    if (formatterType === 'checkbox') {
      return !row[columnName] || alwaysEditableCheckbox ? (
        <CheckBoxCellRender
          rowData={row}
          redflag={redflag}
          columnName={columnName}
          updateRowValue={onChange}
        />
      ) : (
        row[columnName]
      );
    }
    if (formatterType === 'textarea') {
      debugger;
      return (
        <CommnetsCellRender
        
          rowData={row}
          columnName={columnName}
          updateRowValue={onChange}
        />
      );
    }
    if (formatterType === 'statusList') {
      return (
        <StatusCellRender
          rowData={row}
          hasTouched={hasTouched}
          updateRowValue={handleStatusChange}
          required={requiredFields.includes(formatterType)}
          listArray={listArray}
          col={col}
        />
      );
    }
    if (formatterType === 'DrugstatusList') {
      return (
        <DrugStatusCellRender
        reasonErr={reasonErr}
        err1={err1}
          rowData={row}
          hasTouched={hasTouched}
          updateRowValue={handleStatusChange}
          required={requiredFields.includes(formatterType)}
          listArray={listArray}
          col={col}
        />
      );
    }
    

    if (formatterType === 'statusList2') {
      return (
        <StatusCellRender
        errstatus={errstatus}
          rowData={row}
          hasTouched={hasTouched}
          updateRowValue={handleStatusChange}
          required={requiredFields.includes(formatterType)}
          listArray={listArray}
          col={col}
        />
      );
    }
    if (formatterType === 'date') {
      return (
        <InputDateCellRender
          rowData={row}
          crosswalktab={crosswalktab}
          columnName={columnName}
          updateRowValue={onChange}
          endDateFormatter={endDateFormatter}
          terminationDateProp= {terminationDateProp}
          showWarning={showWarning}
          setEffectiveTempDate={setEffectiveTempDate}
          effectiveTempDate={effectiveTempDate}

        />
      );
    }
    if(formatterType === 'Numericnumber'){
      return(
        <InputNumericNumberCellRender
          rowData={row}
          columnName={columnName}
          updateRowValue={onChange}
          required={true}
          validationError={validationError}        
        />
      )
    }
    if (formatterType === 'number') {
      return (
        <InputNumberCellRender
        wacErr={wacErr}
        wacErrZero={wacErrZero}
          rowData={row}
          columnName={columnName}
          updateRowValue={onChange}
          required={true}
          disabled={disabled}
          hasTouched={hasTouched}
          crosswalktab={crosswalktab}
          editPhoneNumber={editPhoneNumber}
        />);
    }
    return (
      <InputCellRender
      errAccountNum={errAccountNum}
        rowData={row}
        columnName={columnName}
        updateRowValue={onChange}
        hasTouched={hasTouched}
        //showWarning={showWarning}
        validationError={validationError}
        required={requiredFields.includes('text')}
      />
    );
  } else if (formatterType === 'date') {
    if (row[columnName]) {
      return (
        <span>{moment(new Date(row[columnName])).format('MM/DD/YYYY')}</span>
      );
    }
    return <>{'-'}</>;
  }
  return <>{row[columnName] || '-'}</>;
};

export default CellEditRender;
